// TODO: consider if that's appropriate to remove dependency on @ocx/graphql

// eslint-disable-next-line @nx/enforce-module-boundaries
import { AssetKey } from '@ocx-app/modules/configuration/app-config.types';

// It's a copy-paste from @ocx/graphql, that's why it's an enum
export enum PointsStrategy {
  Cents = 'CENTS',
  NotUsed = 'NOT_USED',
  Points = 'POINTS',
}

type LoyaltyCurrencyIconVariant = 'single' | 'multiple';
type LoyaltyCurrencyIconConfig = Record<LoyaltyCurrencyIconVariant, AssetKey>;

type LoyaltyCurrencyConfig =
  | {
      pointsStrategy: PointsStrategy.NotUsed;
      iconConfig: null;
    }
  | {
      pointsStrategy: PointsStrategy.Points | PointsStrategy.Cents;
      iconConfig: LoyaltyCurrencyIconConfig;
    };

export type { LoyaltyCurrencyIconVariant, LoyaltyCurrencyIconConfig, LoyaltyCurrencyConfig };
